import staticHeaderHoliday from '../assets/landing/header-static-holiday.png'
import staticHeaderNewYear from '../assets/landing/header-static-new-year.png'
import staticHeaderRegular from '../assets/landing/header-static-regular.png'
import { getHeaderType } from '../utils/headerType'

const HEADER_IMAGES = {
  regular: { src: staticHeaderRegular, width: 780, height: 820 },
  'new-year': { src: staticHeaderNewYear, width: 780, height: 770 },
  holiday: { src: staticHeaderHoliday, width: 780, height: 800 },
}

export default function StaticPhotoHeader() {
  const { src, width, height } = HEADER_IMAGES[getHeaderType()]

  return (
    <img
      src={src}
      className='w-full h-full object-cover'
      loading='eager'
      width={width}
      height={height}
      style={{ aspectRatio: `${width}/${height}` }}
      alt='Header image'
    />
  )
}
